<script>
	import Video from './../components/Video.svelte';
    import Header from './partials/Header.svelte';
    import Footer from './partials/Footer.svelte';
    import Compete from './partials/Compete.svelte';
    import Contest from './partials/Contest.svelte';
    import ContestDiamond from './partials/ContestDiamond.svelte';
    import Format from './partials/Format.svelte';
	import Insider from './partials/Insider.svelte';
	import Project from '../models/project';
    import HomePageVideos from '../components/HomePageVideos.svelte';
    import InvitedTeams from '../components/InvitedTeams.svelte';

</script>
<Header />
<slot></slot>
<!-- <Contest /> -->
{#if !$Project.comingsoonOpen}
	<HomePageVideos />
	<div class="home-page">
		<Format />
	</div>
	<Compete />
	<InvitedTeams />
{/if}
<Insider />
<!-- <ContestDiamond /> -->
<Footer />